export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8853.920f0476.jpg";